module.exports = __webpack_public_path__ + "img/foodtype-english.cc84c17e.png";